export var IngestionPipelineErrorSource;
(function (IngestionPipelineErrorSource) {
    IngestionPipelineErrorSource["INGESTION_PIPELINE_ERROR_SOURCE_LOG"] = "LOG";
    IngestionPipelineErrorSource["INGESTION_PIPELINE_ERROR_SOURCE_METRIC"] = "METRIC";
})(IngestionPipelineErrorSource || (IngestionPipelineErrorSource = {}));
